import "./App.css";
import React from "react";
import { AppProvider } from "@toolpad/core";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { theme } from "./theme/theme";
import { RouterProvider } from "react-router";
import { router } from "./routing/router";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <RouterProvider router={router} />
        </LocalizationProvider>
      </AppProvider>
    </ThemeProvider>
  );
}
